import {
  GET_OPENINGHOUR_SUCCESS,
  GET_OPENINGHOUR_FAIL,

  ADD_NEW_OPENINGHOUR_SUCCESS,
  ADD_NEW_OPENINGHOUR_FAIL,

  GET_OPENINGHOUR_DETAILS_SUCCESS,
  GET_OPENINGHOUR_DETAILS_FAIL,

  UPDATE_OPENINGHOUR_SUCCESS,
  UPDATE_OPENINGHOUR_FAIL,

  STATUS_CHANGE_OPENINGHOUR_SUCCESS,
  STATUS_CHANGE_OPENINGHOUR_FAIL,

  DELETE_OPENINGHOUR_SUCCESS,
  DELETE_OPENINGHOUR_FAIL,
  
  SAVE_ORDERING_OPENINGHOUR_SUCCESS,
  SAVE_ORDERING_OPENINGHOUR_FAIL,
  SAVE_ORDERING_OPENINGHOUR_RESET_FLAG,

  RESET_OPENINGHOUR_FLAG,
  MODIFY_OPENINGHOUR_FLAG,
} from "./actionTypes";

const INIT_STATE = {
  openinghour: []
};

const OpeningHour = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_OPENINGHOUR_SUCCESS:
      return {
        ...state,
        openinghour: action.payload.data,
        totalDataCount: action.payload.count,
        isSuccess: true
      };

    case GET_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        totalDataCount: 0,
        isSuccess: false
      };
    
    //Add New
    case ADD_NEW_OPENINGHOUR_SUCCESS:
      return {
        ...state,
        openinghour: [...state.openinghour, action.payload.data],
        success: action.payload.message,
        isOpeningHourAdd: true,
        isOpeningHourAddFail: false,
      };

    case ADD_NEW_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        isOpeningHourAdd: false,
        isOpeningHourAddFail: true,
      };

    //Details
    case GET_OPENINGHOUR_DETAILS_SUCCESS:
      return {
        ...state,
        details: action.payload.data,
      };

    case GET_OPENINGHOUR_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload.message,
      };

    //Update
    case UPDATE_OPENINGHOUR_SUCCESS:
      return {
        ...state,
        openinghour: state.openinghour.map(step =>
          step._id.toString() === action.payload.data._id.toString()
            ? { ...step, ...action.payload.data }
            : step
        ),
        success: action.payload.message,
        isOpeningHourUpdate: true,
        isOpeningHourUpdateFail: false
      };

    case UPDATE_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        isOpeningHourUpdate: false,
        isOpeningHourUpdateFail: true,
      };

    
    //Status Change
    case STATUS_CHANGE_OPENINGHOUR_SUCCESS:
      return {
        ...state,
        openinghour: state.openinghour.map(getData =>
          getData._id.toString() === action.payload.data._id.toString()
            ? { ...getData, ...action.payload.data }
          : getData
        ),
        success: action.payload.message,
        statusSuccess: true,
        statusFaild: false,
      };
        
    case STATUS_CHANGE_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        statusSuccess: false,
        statusFaild: true,
      };

    //Delete
    case DELETE_OPENINGHOUR_SUCCESS:
      return { 
        ...state,
        openinghour: state.openinghour.filter(getData =>
          {
            //console.log(getData, action.payload);
            return getData._id !== action.payload.data._id
          }
          
        ),
        success: action.payload.message,
        statusSuccess: true,
        statusFaild: false,
      };
  
    case DELETE_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        statusSuccess: false,
        statusFaild: true,
      };
  
    //Save Ordering
    case SAVE_ORDERING_OPENINGHOUR_SUCCESS:
      return {
        ...state,
        success: action.payload.message,
        saveOrderingSuccess: true,
        saveOrderingFaild: false,
      };
        
    case SAVE_ORDERING_OPENINGHOUR_FAIL:
      return {
        ...state,
        error: action.payload.message,
        saveOrderingSuccess: false,
        saveOrderingFaild: true,
      };

    //Save Ordering reset flag 
    case SAVE_ORDERING_OPENINGHOUR_RESET_FLAG:
      return {
        ...state,
        saveOrderingSuccess: false,
        saveOrderingFaild: false,
        error: false
      };

    //Modify flag  
    case MODIFY_OPENINGHOUR_FLAG:
      return {
        ...state,
        statusSuccess: false,
        statusFaild: false,
        error: false
      };
    
    //Reset Flag
    case RESET_OPENINGHOUR_FLAG:
      return {
        ...state,
        isOpeningHourAdd: false,
        isOpeningHourAddFail: false,
        isSuccess: false,
        isOpeningHourDetails: false,
        isOpeningHourUpdate: false,
        isOpeningHourUpdateFail: false,
        error: false
      };

    default:
      return state;
  }
};

export default OpeningHour;
